import React from "react";
import { useRouteError, Link, useNavigate } from "react-router-dom";

// library import

import { HomeIcon, ArrowUturnLeftIcon } from "@heroicons/react/20/solid";

import './Error.css';

const Error: React.FC = () => {

  const error = useRouteError() as Error;
  const navigate = useNavigate();

  return (
    <div className="error">
      <h1>Opz! C'è stato un problema</h1>

      <p>{error.message}</p>
      <div className="flex-md">
        <button className="btn btn--dark" onClick={() => navigate(-1)}>
          <ArrowUturnLeftIcon width={20} />
          <span>Torna indietro</span>
        </button>
        <Link to="/" className="btn btn--dark">
          <HomeIcon width={20} />
          <span>Vai alla home</span>
        </Link>
      </div>
    </div>
  );
}

export default Error;
